import PropTypes from 'prop-types'
import React from 'react'
import styles from './Pills.module.css'

export const Pills = props => (
  <div className={styles.wrapper}>{props.children}</div>
)

Pills.propTypes = {
  children: PropTypes.node.isRequired
}

Pills.displayName = 'Pills'

export const Pill = props => {
  return (
    <div
      className={styles.item}
      data-active={props.isActive}
      onClick={() => props.onClick(props.name)}
      data-disabled={props.isDisabled}
    >
      {props.name}
    </div>
  )
}

Pill.defaultProps = {
  isDisabled: false,
  isActive: false
}

Pill.propTypes = {
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  isActive: PropTypes.bool
}

Pill.displayName = 'Pill'



// WEBPACK FOOTER //
// ./ui/Pills.js